
import React, { useState, useEffect } from 'react';
import './EjecutaTratamientoModal.css';

export default function EjecutaTratamientoModal({ onClose, onStart, tratamientoId }) {
  const [step, setStep] = useState(1);
  const [skipWarning, setSkipWarning] = useState(false);
  const [skipInstructions, setSkipInstructions] = useState(false);

  // Claves únicas por tratamiento
  const warningKey = `skipTratamientoWarning_${tratamientoId}`;
  const instructionsKey = `skipTratamientoInstructions_${tratamientoId}`;

  // Guardar preferencia en localStorage por tratamiento
  const handleSkipWarning = (checked) => {
    setSkipWarning(checked);
    if (checked) localStorage.setItem(warningKey, '1');
    else localStorage.removeItem(warningKey);
  };
  const handleSkipInstructions = (checked) => {
    setSkipInstructions(checked);
    if (checked) localStorage.setItem(instructionsKey, '1');
    else localStorage.removeItem(instructionsKey);
  };

  // Si ya está guardado, saltar pasos
  useEffect(() => {
    if (localStorage.getItem(warningKey)) setStep(2);
    if (localStorage.getItem(instructionsKey)) setStep(3);
  }, [warningKey, instructionsKey]);


  // Llamar a onStart solo cuando step === 3, pero fuera del render
  useEffect(() => {
    if (step === 3) {
      onStart();
    }
  }, [step, onStart]);

  if (step === 3) {
    return null;
  }

  return (
    <div className="ejecuta-modal-overlay">
      <div className="ejecuta-modal-box">
        {step === 1 && (
          <>
            <img src="/advertencia.png" alt="Advertencia" className="ejecuta-modal-icon" />
            <div className="ejecuta-modal-texto">
              <strong>¡Advertencia!</strong><br />
              No utilizar en caso de fotosensibilidad, diagnóstico de epilepsia, haber sufrido de consulsiones o desmayos alguna vez.<br />
              Suspender el uso si siente algún malestar físico como por ejemplo dolor de cabeza mientras lo usa.<br />
              Puede contactar a su psicólogo o neuroterapeuta desde la app.
            </div>
            <div className="ejecuta-modal-actions">
              <label className="ejecuta-modal-checkbox">
                <input type="checkbox" checked={skipWarning} onChange={e => handleSkipWarning(e.target.checked)} />
                No mostrar más para este tratamiento
              </label>
              <button className="ejecuta-modal-btn" onClick={() => setStep(2)}>Siguiente</button>
            </div>
          </>
        )}
        {step === 2 && (
          <>
            <div className="ejecuta-modal-icons-row">
              <img src="/auriculares.png" alt="Auriculares" className="ejecuta-modal-icon-small" />
              <img src="/horizontal.png" alt="Horizontal" className="ejecuta-modal-icon-small" />
              <img src="/luna.png" alt="Ambiente oscuro" className="ejecuta-modal-icon-small" />
            </div>
            <div className="ejecuta-modal-texto">
              <strong>INSTRUCCIONES</strong><br />
              Utilizar con auriculares y en modo horizontal.<br />
              Preferiblemente utilizar en un ambiente oscuro.
            </div>
            <div className="ejecuta-modal-actions">
              <label className="ejecuta-modal-checkbox">
                <input type="checkbox" checked={skipInstructions} onChange={e => handleSkipInstructions(e.target.checked)} />
                No mostrar más para este tratamiento
              </label>
              <button className="ejecuta-modal-btn" onClick={() => setStep(3)}>Siguiente</button>
            </div>
          </>
        )}
        <button className="ejecuta-modal-close" onClick={onClose}>×</button>
      </div>
    </div>
  );
}
